/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
    visitor: false,
    customer: false,
    repari: false,
    yuyue: false
};

// getters
const getters = {
};

// mutations
const mutations = {
    IS_READ (state, data) {
        if (data.fangke > 0) {
            state.visitor = true
        } else {
            state.visitor = false
        }
        if (data.yonghu > 0) {
            state.customer = true
        } else {
            state.customer = false
        }
        if (data.repari > 0) {
            state.repari = true
        } else {
            state.repari = false
        }
        if (data.yuyue > 0) {
            state.yuyue = true
        } else {
            state.yuyue = false
        }
    }
};

// actions
const actions = {
    // 访客列表
    AuditvisitorsListShow ({ commit }, data) {
        return axios.post(http + '/org/user/userinvite_list', data).then(res => {
            return res.data
        })
    },
    // 同意访客
    AgreeAuditvisitors ({ commit }, data) {
        return axios.post(http + '/org/user/userinvite_agree', data).then(res => {
            return res.data
        })
    },
    // 忽略访客
    IgnoreAuditvisitors ({ commit }, data) {
        return axios.post(http + '/org/user/cancel_userinvite', data).then(res => {
            return res.data
        })
    },
    // 红点
    Isread ({ commit }, data) {
        return axios.post(http + '/Enum/hongdian', data).then(res => {
            commit('IS_READ', res.data.data)
            return res.data
        })
    }
    // 用户名登录
    // NoticeAdministrationListShow({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/show', data).then(res => {
    //         return res.data
    //     })
    // },
    // AddNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/add', data).then(res => {
    //         return res.data
    //     })
    // },
    // DeleteNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/delete', data).then(res => {
    //         return res.data
    //     })
    // }
};

const AuditvisitorsModule = {
    state,
    getters,
    actions,
    mutations
}
export default AuditvisitorsModule